import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, Injector, NgModuleFactory, OnInit, PLATFORM_ID, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { GeneratorEnv, GENERATOR_ENV_TOKEN } from '../../generator-env-token';
import { TemplateLoaderService } from '../service/template-loader.service';
import { TemplateService } from '../service/template.service';
// import * as $ from 'jquery';
import { MemberProxyService } from 'src/app/member/service/member-proxy.service';
import { CultureCenterService } from 'src/app/member/module/culture-center-member/cultureCenter.service';
import { closestPolifill, loadLazyCssFile } from 'src/app/util';
import { UserService } from 'src/app/share/service/user.service';
import { fadeInOutAnimation } from 'src/app/share/entity/animation';
import * as moment from 'moment';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { LoggerService } from 'src/app/share/service/logger.service';

@Component({
  selector: 'app-template-generator',
  templateUrl: './template-generator.component.html',
  styleUrls: ['./template-generator.component.scss'],
  animations: [fadeInOutAnimation],
})
export class TemplateGeneratorComponent implements OnInit, AfterViewInit {
  component: any;
  module: NgModuleFactory<any>;
  templateInjector: Injector;
  @ViewChild('container', { read: ViewContainerRef, static: false })
  container: ViewContainerRef;
  isBrowser = true;
  showCookiesClaim = false;

  constructor(
    @Inject(GENERATOR_ENV_TOKEN) private generatorEnv: GeneratorEnv,
    private templateService: TemplateService,
    private router: Router,
    private templateLoader: TemplateLoaderService,
    private memberProxyService: MemberProxyService,
    private cultureCenterService: CultureCenterService,
    @Inject(PLATFORM_ID) private platformId: object,
    private render: Renderer2,
    private el: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private userService: UserService,
    private serverConfigService: ServerConfigService,
    private loggerService: LoggerService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    closestPolifill();
    if (!this.isBrowser) {
      this.loggerService.info(`TemplateGeneratorComponent create`);
    }
  }

  ngAfterViewInit() {
    if (!this.isBrowser) {
      this.loggerService.info(`TemplateGeneratorComponent AfterViewInit`);
    }
    if (this.isBrowser || !this.serverConfigService.isEditModeUrl) {
      if (!this.isBrowser) {
        this.loggerService.info(`TemplateGeneratorComponent AfterViewInit1`);
      }
      this.templateService.siteInfo$.subscribe(siteInfo => {
        const template = this.templateService.template;
        if (!this.isBrowser) {
          // this.loggerService.info(`TemplateGeneratorComponent AfterViewInit get template:`, JSON.stringify(template));
        }

        try {
          // 載入theme
          loadLazyCssFile(this.render, this.el.nativeElement, `${template.selector}${template.themeClass}Style`, `/assets/theme/${template.selector}/${template.themeClass}.css`, !this.isBrowser);
          if (!this.isBrowser) {
            this.loggerService.info(`TemplateGeneratorComponent AfterViewInit after loadLazyCssFile`);
          }
          this.render.addClass(this.document.body, template.themeClass);
          if (!this.isBrowser) {
            this.loggerService.info(`TemplateGeneratorComponent AfterViewInit after addClass to body`);
          }

          // 載入template
          if (!this.isBrowser) {
            this.loggerService.info(`TemplateGeneratorComponent AfterViewInit load template`);
          }
          this.templateLoader.load(template.selector, this.container);
        } catch (error) {
          if (!this.isBrowser) {
            this.loggerService.info(`TemplateGeneratorComponent AfterViewInit catch error`, error);
          }
        }
      });
    }
  }

  ngOnInit() {
    if (!this.isBrowser) {
      this.loggerService.info(`TemplateGeneratorComponent OnInit`);
    }
    this.templateService.siteInfo$.subscribe(siteInfo => {
      const siteMeta = this.templateService.siteMeta;
      this.render.setAttribute(this.document.head.querySelector('link[rel=icon]'), 'href', siteMeta.icoFile[0].url);
    });

    if (this.isBrowser || !this.serverConfigService.isEditModeUrl) {
      if (!this.isBrowser) {
        this.loggerService.info(`TemplateGeneratorComponent OnInit before init member`);
      }
      // 文化部會員中心
      this.memberProxyService.init();
      this.cultureCenterService.init();
      this.userService.init(this.memberProxyService);
      if (!this.isBrowser) {
        this.loggerService.info(`TemplateGeneratorComponent OnInit after init member`);
      }

      if (this.isBrowser && !this.serverConfigService.isEditModeUrl) {
        if (localStorage.getItem('hasAnswerCookiesClaim') !== '1') {
          this.showCookiesClaim = true;
        } else {
          const expiredTime = localStorage.getItem('cookiesClaimExpireTime');
          if (!expiredTime) {
            localStorage.setItem('cookiesClaimExpireTime', moment().add(30, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss.sss'));
          } else if (moment().isAfter(moment(expiredTime))) {
            localStorage.removeItem('hasAnswerCookiesClaim');
            localStorage.removeItem('cookiesClaimExpireTime');
            this.showCookiesClaim = true;
          }
        }
      }
    }
  }

  acceptCookies() {
    this.showCookiesClaim = false;
    localStorage.setItem('hasAnswerCookiesClaim', '1');
    localStorage.setItem('cookiesClaimExpireTime', moment().add(30, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss.sss'));
  }
}
